<template>
    <div>
        <div class="service-selector">
            <ul class="service-list">
                <li v-for="item in $root.services" :key="item.url" :class="{ active: $root.serviceActive === item }" @click="changeRouteService(item.url)" v-html="item.name"></li>
            </ul>

            <div v-if="$root.serviceActive" class="tab-content section">
                <div class="tab active" v-if="$root.serviceActive.url === 'abonament'">
                    <section class="section section--gutter no-gutter--top section--gallery no-gutter--bottom">
                        <!-- country groups -->
                        <post-paid-cards-offers v-if="$root.selectedCountry.countryGroup === 1 || $root.selectedCountry.countryGroup === 2 || $root.selectedCountry.countryGroup === 3" :countryGroup="$root.selectedCountry.countryGroup"> </post-paid-cards-offers>
                        <!-- end country groups -->

                        <!-- country zones -->
                        <post-paid-cards-zone-offers v-else :countryZone="$root.selectedCountry.postpaid"> </post-paid-cards-zone-offers>
                        <!-- country zones -->
                    </section>
                </div>
                <div class="tab active" v-if="$root.serviceActive.url === 'cartela'">
                    <div class="section section--gutter">
                        <div class="spring">
                            <div v-if="['GB', 'GI'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1">
                                <div v-if="['GB'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1">
                                    <card-offers-pre-paid :offers="$root.selectedCountry.prePaidOffers" :selectedCountry="$root.selectedCountry"> </card-offers-pre-paid>

                                    <h2 class="heading heading--4 heading--light heading--leading heading--center">Costuri standard</h2>

                                    <card-standard-tarifs :selectedCountry="$root.selectedCountry" :zoneProps="tab_1_data"></card-standard-tarifs>
                                </div>

                                <div v-if="['GI'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1">
                                    <h2 class="heading heading--4 heading--light heading--leading heading--center">Costuri standard</h2>

                                    <card-standard-tarifs :selectedCountry="$root.selectedCountry" :zoneProps="tab_1_data"></card-standard-tarifs>
                                </div>
                            </div>

                            <div v-else>
                                <slick v-if="loadSliders" ref="slickSlider-1" class="ro_slider section--gutter no-gutter--bottom no-gutter--top" :options="slickOptions">
                                    <!-- <offer-prepaid-1 v-if="$root.selectedCountry.prepaid === 1"></offer-prepaid-1> -->

                                    <offer-prepaid-4 v-if="$root.selectedCountry.prepaid === 1"></offer-prepaid-4>

                                    <offer-prepaid-15 v-if="$root.selectedCountry.prepaid === 1"></offer-prepaid-15>

                                    <offer-prepaid-35 v-if="$root.selectedCountry.prepaid === 1"></offer-prepaid-35>

                                    <offer-prepaid-4 v-if="['TR', 'AL', 'MK', 'ME', 'RS', 'BA'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1"></offer-prepaid-4>

                                    <offer-prepaid-15 v-if="['CH', 'AU', 'CA', 'CH', 'HK', 'IN', 'ID', 'IL', 'JP', 'JE', 'KE', 'KV', 'MK', 'MY', 'MD', 'QA', 'RS', 'SG', 'US', 'TH', 'TR', 'VN', 'EG', 'AL', 'UA', 'JO', 'BA'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1"></offer-prepaid-15>

                                    <offer-prepaid-35 v-if="['AE', 'AR', 'BH', 'BD', 'BR', 'CL', 'CN', 'CO', 'DO', 'GE', 'IQ', 'IM', 'JM', 'JO', 'KZ', 'MX', 'MC', 'ME', 'PS', 'PE', 'PR', 'RU', 'SA', 'LK', 'TW', 'UA', 'UY', 'TR'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1"></offer-prepaid-35>
                                </slick>
                            </div>
                        </div>
                    </div>
                    <section v-if="$root.selectedCountry" class="section section--gutter no-gutter--top">
                        <div v-if="$root.selectedCountry.prepaid !== 1" class="spring">
                            <h2 class="heading heading--4 heading--light heading--leading heading--center">Costuri standard</h2>
                            <!-- condition to show unavailable roaming message -->
                            <div v-if="['CU', 'DJ', 'EC', 'FK', 'GD', 'HT', 'LY', 'NF', 'SD', 'SM', 'SO', 'TL', 'VE', 'WS', 'KIR', 'SATEL'].indexOf(CURRENT_COUNTRY_ISO_CODE) !== -1">
                                <h3 class="heading heading--5 heading-light heading--leading heading--center">Pentru această destinație, serviciul Roaming este indisponibil.</h3>
                            </div>
                            <!-- end condition; normal table below -->
                            <div class="card" v-else>
                                <table class="table--partners table-responsive table">
                                    <thead>
                                        <tr class="table__tr">
                                            <th class="table__th">Apeluri efectuate local</th>
                                            <th class="table__th">Apeluri efectuate către RO</th>
                                            <th class="table__th">Apel international UE</th>
                                            <th class="table__th">Apel international non-UE</th>
                                            <th class="table__th">Apeluri primite</th>
                                            <th class="table__th">Sms trimis</th>
                                            <th class="table__th">Internet pe mobil</th>
                                        </tr>
                                    </thead>
                                    <tbody class="table__body">
                                        <tr class="table__tr">
                                            <td class="table__td">
                                                <strong>
                                                    {{ tab_1_data.Apel_local }}
                                                    <span title="per">&euro;/</span>
                                                    <span title="minute">min</span>
                                                </strong>
                                            </td>
                                            <td class="table__td">
                                                <strong>
                                                    {{ tab_1_data.Apel_ro }}
                                                    <span title="per">&euro;/</span>
                                                    <span title="minute">min</span>
                                                </strong>
                                            </td>
                                            <td class="table__td">
                                                <strong>
                                                    {{ tab_1_data.Apel_ue }}
                                                    <span title="per">&euro;/</span>
                                                    <span title="minute">min</span>
                                                </strong>
                                            </td>
                                            <td class="table__td">
                                                <strong>
                                                    {{ tab_1_data.Apel_non_ue }}
                                                    <span title="per">&euro;/</span>
                                                    <span title="minute">min</span>
                                                </strong>
                                            </td>
                                            <td class="table__td">
                                                <strong>
                                                    {{ tab_1_data.Apel_primit }}
                                                    <span title="per">&euro;/</span>
                                                    <span title="minute">min</span>
                                                </strong>
                                            </td>
                                            <td class="table__td">
                                                <strong>
                                                    {{ tab_1_data.SMS_trimis }}
                                                    <span title="per">&euro;/</span>
                                                    <span title="sms">sms</span>
                                                </strong>
                                            </td>
                                            <td class="table__td text-center">
                                                <span v-if="this.$root.selectedCountry.countryCodeISO != 'MV'">
                                                    <strong v-if="['SY', 'TM'].indexOf($root.selectedCountry.countryCodeISO) !== -1">--</strong>
                                                    <strong v-else>
                                                        {{ tab_1_data.GPRS }}
                                                        <span title="per">&euro;/</span>
                                                        <span title="minute">MB</span>
                                                    </strong>
                                                </span>
                                                <strong v-else>8 €/ MB</strong>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="padding-increase--top padding-increase--bottom" v-if="['RU'].indexOf($root.selectedCountry.countryCodeISO) !== -1">
                                    <h3 class="heading heading--5 heading--bold heading--leading heading--center">Pentru regiunile Samara si Tyumen, serviciul Roaming este indisponibil.</h3>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
                <div class="tab active" v-if="$root.serviceActive.url === 'internet'">
                    <section v-if="$root.selectedCountry" class="section section--gutter">
                        <div class="spring spring--md">
                            <h2 class="heading heading--4 heading--light heading--leading heading--center">Costurile standard</h2>
                            <div v-if="$root.selectedCountry.internet !== 1" class="js-component-component component__component" data-component="charges">
                                <div class="standard-costs grid--gutter grid text-center">
                                    <div class="grid__item grid__item--align-center grid__item--gutter grid__item--sm-1/2 grid__item--1/4">
                                        <span v-if="this.$root.selectedCountry.countryCodeISO != 'MV'">
                                            {{ tab_2_data.GPRS }}
                                            <span title="per">&euro;/</span>
                                            <span title="minute">MB</span>
                                            <div class="small">Internet pe mobil</div>
                                        </span>
                                        <span v-else> Serviciu indisponibil </span>
                                    </div>
                                </div>
                            </div>
                            <h3 v-if="$root.selectedCountry.internet === 1" class="heading heading--5 heading--light heading--leading heading--center mt-20">Ai roaming ca acasă în &#355;ările din Spa&#355;iul Economic European (SEE): Uniunea Europeană + Islanda, Norvegia și Liechtenstein, în condi&#355;iile politicii de utilizare rezonabilă;</h3>
                        </div>
                    </section>
                    <div v-if="$root.selectedCountry" class="spring">
                        <slick v-if="loadSliders" ref="slickSlider-2" class="ro_slider" :options="slickOptions">
                            <div v-if="['CH', 'AL', 'TR'].indexOf($root.selectedCountry.countryCodeISO) !== -1" class="iml__slide">
                                <section class="section section--gutter no-gutter--top">
                                    <div class="spring">
                                        <div class="js-component-component component__component" data-component="world-traveller-bundle">
                                            <div class="bundle bundle--horizontal">
                                                <div class="bundle__summary">
                                                    <div class="grid">
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/1 grid__item--1/1">
                                                            <h4 class="grid--gutter gutter--md-bottom grid">
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                                                    <svg focusable="false" aria-hidden="true" class="icon icon--extra-large icon--empty">
                                                                        <use xlink:href="#icon-world-mid" />
                                                                    </svg>
                                                                </span>
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom" style="display: block">
                                                                    <span class="heading heading--4 heading--light heading--leading heading--trailing">Date Smart</span>
                                                                    <span class="bundle-price">
                                                                        <strong class="bundle-price__cost bundle-price__cost--sm">0,99&euro;</strong>
                                                                        <span title="per">/</span>24h
                                                                    </span>
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/1 grid__item--1/1 grid__item--aligh-left flush--sm-bottom"></div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/1 grid__item--1/1 grid__item--aligh-right flush--sm-bottom">
                                                            <a :href="hrefActivate" data-js="_dialog" data-stamp="roaming-add-on-opt-in-world-traveller" class="button button--primary no-gutter--bottom" role="button" aria-haspopup="true">Activează</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                                                    <div :class="{ activeMore: toggle_in_slide_1 }" class="js-accordion-content show-more__content show-more__content--collapse" style="display: none" tabindex="0">
                                                        <div class="bundle__inclusions">
                                                            <ul class="grid--gutter grid">
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic inclus: 50MB/ 24h</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Tarif trafic suplimentar: 0,06€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic în alţi operatori: 9,75€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-center grid__item--gutter grid__item--1/1 mt-20">Pre&#355;urile sunt exprimate în Euro și includ TVA.</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <button-more @click.native="toggle_in_slide_1 = !toggle_in_slide_1" :more="toggle_in_slide_1" prefix="Mai"></button-more>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div v-if="['CH', 'AL', 'TR'].indexOf($root.selectedCountry.countryCodeISO) !== -1" class="iml__slide">
                                <section class="section section--gutter no-gutter--top">
                                    <div class="spring">
                                        <div class="js-component-component component__component" data-component="world-traveller-bundle">
                                            <div class="bundle bundle--horizontal">
                                                <div class="bundle__summary">
                                                    <div class="grid">
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/1 grid__item--1/1">
                                                            <h4 class="grid--gutter gutter--md-bottom grid">
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                                                    <svg focusable="false" aria-hidden="true" class="icon icon--extra-large icon--empty">
                                                                        <use xlink:href="#icon-world-mid" />
                                                                    </svg>
                                                                </span>
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                                                    <span class="heading heading--4 heading--light heading--leading heading--trailing">Vodafone Mobil Broadband Roaming</span>
                                                                    <span class="bundle-price">
                                                                        <strong class="bundle-price__cost bundle-price__cost--sm">7,14&euro;</strong>
                                                                        <span title="per">/</span>24h
                                                                    </span>
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/2 grid__item--1/3 grid__item--aligh-left flush--sm-bottom"></div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/2 grid__item--1/1 grid__item--aligh-right flush--sm-bottom">
                                                            <a :href="hrefActivate" data-js="_dialog" data-stamp="roaming-add-on-opt-in-world-traveller" class="button button--primary no-gutter--bottom" role="button" aria-haspopup="true">Activează</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                                                    <div :class="{ activeMore: toggle_in_slide_2 }" class="js-accordion-content show-more__content show-more__content--collapse" style="display: none" tabindex="0">
                                                        <div class="bundle__inclusions">
                                                            <ul class="grid--gutter grid">
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic inclus: 150MB/ 24h</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Tarif trafic suplimentar: 0,06€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic în alţi operatori: 9,52€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-center grid__item--gutter grid__item--1/1 mt-20">Pre&#355;urile sunt exprimate în Euro și includ TVA.</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <button-more @click.native="toggle_in_slide_2 = !toggle_in_slide_2" :more="toggle_in_slide_2" prefix="Mai"></button-more>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div v-if="['ZA', 'AU', 'EG', 'GH', 'HK', 'IN', 'JP', 'MY', 'NZ', 'QA', 'SG', 'US'].indexOf($root.selectedCountry.countryCodeISO) !== -1" class="iml__slide">
                                <section class="section section--gutter no-gutter--top">
                                    <div class="spring">
                                        <div class="js-component-component component__component" data-component="world-traveller-bundle">
                                            <div class="bundle bundle--horizontal">
                                                <div class="bundle__summary">
                                                    <div class="grid">
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/1 grid__item--1/1">
                                                            <h4 class="grid--gutter gutter--md-bottom grid">
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                                                    <svg focusable="false" aria-hidden="true" class="icon icon--extra-large icon--empty">
                                                                        <use xlink:href="#icon-world-mid" />
                                                                    </svg>
                                                                </span>
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom" style="display: block">
                                                                    <span class="heading heading--4 heading--light heading--leading heading--trailing">Date Smart</span>
                                                                    <span class="bundle-price">
                                                                        <strong class="bundle-price__cost bundle-price__cost--sm">5,95&euro;</strong>
                                                                        <span title="per">/</span>24h
                                                                    </span>
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/1 grid__item--1/1 grid__item--aligh-left flush--sm-bottom"></div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/2 grid__item--1/1 grid__item--aligh-right flush--sm-bottom">
                                                            <a :href="hrefActivate" data-js="_dialog" data-stamp="roaming-add-on-opt-in-world-traveller" class="button button--primary no-gutter--bottom" role="button" aria-haspopup="true">Activează</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                                                    <div :class="{ activeMore: toggle_in_slide_3 }" class="js-accordion-content show-more__content show-more__content--collapse" style="display: none" tabindex="0">
                                                        <div class="bundle__inclusions">
                                                            <ul class="grid--gutter grid">
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic inclus: 50MB/ 24h</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Tarif trafic suplimentar: 0,20€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic în alţi operatori: 9,75€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-center grid__item--gutter grid__item--1/1 mt-20">Preţurile sunt exprimate în Euro și includ TVA.</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <button-more @click.native="toggle_in_slide_3 = !toggle_in_slide_3" :more="toggle_in_slide_3" prefix="Mai"></button-more>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                            <div v-if="['ZA', 'AU', 'EG', 'GH', 'HK', 'IN', 'JP', 'MY', 'NZ', 'QA', 'SG', 'US'].indexOf($root.selectedCountry.countryCodeISO) !== -1" class="iml__slide">
                                <section class="section section--gutter no-gutter--top">
                                    <div class="spring">
                                        <div class="js-component-component component__component" data-component="world-traveller-bundle">
                                            <div class="bundle bundle--horizontal">
                                                <div class="bundle__summary">
                                                    <div class="grid">
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--md-1/1 grid__item--1/1">
                                                            <h4 class="grid--gutter gutter--md-bottom grid">
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                                                    <svg focusable="false" aria-hidden="true" class="icon icon--extra-large icon--empty">
                                                                        <use xlink:href="#icon-world-mid" />
                                                                    </svg>
                                                                </span>
                                                                <span class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 flush--sm-bottom">
                                                                    <span class="heading heading--4 heading--light heading--leading heading--trailing">Vodafone Mobil Broadband Roaming</span>
                                                                    <span class="bundle-price">
                                                                        <strong class="bundle-price__cost bundle-price__cost--sm">9,52&euro;</strong>
                                                                        <span title="per">/</span>24h
                                                                    </span>
                                                                </span>
                                                            </h4>
                                                        </div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/1 grid__item--1/3 grid__item--aligh-left flush--sm-bottom"></div>
                                                        <div class="grid__item grid__item--middle grid__item--gutter grid__item--sm-1/1 grid__item--md-1/1 grid__item--1/1 grid__item--aligh-right flush--sm-bottom">
                                                            <a :href="hrefActivate" data-js="_dialog" data-stamp="roaming-add-on-opt-in-world-traveller" class="button button--primary no-gutter--bottom" role="button" aria-haspopup="true">Activează</a>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div data-js="_accordion" data-classes="active=show-more__heading--active" class="js-accordion show-more">
                                                    <div :class="{ activeMore: toggle_in_slide_4 }" class="js-accordion-content show-more__content show-more__content--collapse" style="display: none" tabindex="0">
                                                        <div class="bundle__inclusions">
                                                            <ul class="grid--gutter grid">
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic inclus: 150MB/ 24h</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Tarif trafic suplimentar: 0,83€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-left grid__item--gutter grid__item--sm-1/1 grid__item--1/1">
                                                                    <div class="media media--gutter media--gutter--slim">
                                                                        <div class="media__image">
                                                                            <svg focusable="false" aria-hidden="true" class="icon icon--small bundle__inclusion-bullet bundle__inclusion-bullet--static no-gutter--all">
                                                                                <use xlink:href="#icon-tick" />
                                                                            </svg>
                                                                        </div>
                                                                        <div class="media__body">Trafic în alţi operatori: 9,52€ /MB</div>
                                                                    </div>
                                                                </li>
                                                                <li class="grid__item grid__item--align-center grid__item--gutter grid__item--1/1 mt-20">Preţurile sunt exprimate în Euro și includ TVA.</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    <button-more @click.native="toggle_in_slide_4 = !toggle_in_slide_4" :more="toggle_in_slide_4" prefix="Mai"></button-more>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </slick>
                    </div>
                </div>
            </div>

            <div class="tab-content section no-border section--wild-sand" v-if="$root.selectedCountry && $root.serviceActive">
                <!-- undesunt -->
                <li class="heading heading--4 heading--light heading--leading heading--center">Sunt:</li>
                <ul class="tabs__navigation-wrapper">
                    <li class="tabs__tab" v-for="(item, index) in $root.travelTimes" :key="index" :class="{ active: $root.travelTimeActive === item }" @click="changeRouteTravelTime(item.url, item.name)">
                        {{ item.name }}
                    </li>
                </ul>
                <div
                    class="tab"
                    v-if="$root.travelTimeActive"
                    :class="{
                        active: $root.travelTimeActive.url === 'inainte-de-calatorie',
                    }"
                >
                    <div class="spring">
                        <ul class="grid--gutter grid">
                            <li v-for="(tip, index) in $root.travelTips[travelTipsSpace][$root.serviceActive.url]['inainte-de-calatorie']" :key="index" class="grid__item grid__item--gutter grid__item--sm-1/1 grid__item--md-1/3 grid__item--1/3 flush--sm-bottom">
                                <router-link
                                    :to="{
                                        name: 'travel-tips',
                                        params: {
                                            travelTipsSpace: travelTipsSpace,
                                            offerType: $root.serviceActive.url,
                                            tipName: tip.name,
                                            tip: tip,
                                            countryName: $root.selectedCountry.nameClean,
                                            travelTime: 'inainte-de-calatorie',
                                        },
                                    }"
                                    class="link link--tile"
                                >
                                    <span class="chevron">
                                        <span class="chevron__text">
                                            <span class="media media--gutter media--middle">
                                                <span class="link__icon media__image hide--sm">
                                                    <img class="icon icon--empty" v-if="tip.title == 'Acces la serviciu'" src="https://static.vodafone.ro/roaming/images/v546153.png" />
                                                    <img class="icon icon--empty" v-else-if="tip.title == 'Politica de utilizare rezonabilă în SEE'" src="https://static.vodafone.ro/roaming/images/v546155.png" />
                                                    <img class="icon icon--empty" v-else-if="tip.title == 'Asistență directă'" src="https://static.vodafone.ro/roaming/images/v546129.png" />
                                                    <img class="icon icon--empty" v-else src="https://static.vodafone.ro/roaming/images/v546129.png" />
                                                </span>
                                                <span class="media__body">
                                                    <span class="link__heading heading heading--5 heading-lh--22 no-gutter--all">{{ tip.title }}</span>
                                                </span>
                                            </span>
                                        </span>

                                        <span class="chevron__container">
                                            <svg aria-hidden="true" class="icon icon--extra-small chevron__icon chevron__icon--red">
                                                <use xlink:href="#icon-chevron-right" />
                                            </svg>
                                        </span>
                                    </span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div
                    class="tab"
                    v-if="$root.travelTimeActive"
                    :class="{
                        active: $root.travelTimeActive.url === 'in-timpul-calatoriei',
                    }"
                >
                    <div class="spring">
                        <ul class="services-cards">
                            <li v-for="(tip, index) in $root.travelTips[travelTipsSpace][$root.serviceActive.url]['in-timpul-calatoriei']" :key="index" class="tiles__item grid__item--sm-1/1 grid__item--1/1">
                                <router-link
                                    :to="{
                                        name: 'travel-tips',
                                        params: {
                                            travelTipsSpace: travelTipsSpace,
                                            offerType: $root.serviceActive.url,
                                            tipName: tip.name,
                                            tip: tip,
                                            countryName: $root.selectedCountry.nameClean,
                                            travelTime: 'in-timpul-calatoriei',
                                        },
                                    }"
                                >
                                    <div class="services-card__texts">
                                        <span class="chevron__text">{{ tip.title }}</span>
                                        <span class="chevron__container">
                                            <svg aria-hidden="true" class="icon icon--extra-small chevron__icon chevron__icon--red">
                                                <use xlink:href="#icon-chevron-right" />
                                            </svg>
                                        </span>
                                    </div>
                                    <span
                                        class="background-image-tiles"
                                        v-bind:style="{
                                            'background-image': 'url(' + tip.img + ')',
                                        }"
                                        >&nbsp;</span
                                    >
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tab" v-if="$root.travelTimeActive" :class="{ active: $root.travelTimeActive.url === 'dupa-calatorie' }">
                    <div class="spring">
                        <ul class="services-cards">
                            <li v-for="(tip, index) in $root.travelTips[travelTipsSpace][$root.serviceActive.url]['dupa-calatorie']" :key="index" class="tiles__item grid__item--sm-1/1 grid__item--1/1">
                                <router-link
                                    :to="{
                                        name: 'travel-tips',
                                        params: {
                                            travelTipsSpace: travelTipsSpace,
                                            offerType: $root.serviceActive.url,
                                            tipName: tip.name,
                                            tip: tip,
                                            countryName: $root.selectedCountry.nameClean,
                                            travelTime: 'dupa-calatorie',
                                        },
                                    }"
                                >
                                    <div class="services-card__texts">
                                        <span class="chevron__text">{{ tip.title }}</span>
                                        <span class="chevron__container">
                                            <svg aria-hidden="true" class="icon icon--extra-small chevron__icon chevron__icon--red">
                                                <use xlink:href="#icon-chevron-right" />
                                            </svg>
                                        </span>
                                    </div>
                                    <span
                                        class="background-image-tiles"
                                        v-bind:style="{
                                            'background-image': 'url(' + tip.img + ')',
                                        }"
                                        >&nbsp;</span
                                    >
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- end .tab -->
            </div>
        </div>
        <!-- <PartnerOperators></PartnerOperators> -->
        <!-- <download-as-pdf></download-as-pdf> -->
    </div>
</template>

<script>
import Calculator from './Calculator';
import OfferPrepaid_1 from './OfferPrepaid_1.vue';
import OfferPrepaid_4 from './OfferPrepaid_4.vue';
import OfferPrepaid_15 from './OfferPrepaid_15.vue';
import OfferPrepaid_35 from './OfferPrepaid_35.vue';
import ButtonMore from './ButtonMore.vue';
import DownloadAsPdf from './DownloadAsPdf.vue';
import PartnerOperators from './PartnerOperators.vue';
import Slick from './slickCarousel';
import PostPaidCardsOffers from './PostPaidCardsOffers.vue';
import PostPaidCardsZoneOffers from './PostPaidCardsZoneOffers.vue';
import CardOffersPostPaid from './CardOffersPostPaid.vue';
import CardOffersPrePaid from './CardOffersPrePaid.vue';
import CardStandardTarifs from './CardStandardTarifs.vue';

export default {
    name: 'ServiceSelector',
    components: {
        'offer-prepaid-1': OfferPrepaid_1,
        'offer-prepaid-4': OfferPrepaid_4,
        'offer-prepaid-15': OfferPrepaid_15,
        'offer-prepaid-35': OfferPrepaid_35,
        ButtonMore,
        Calculator,
        DownloadAsPdf,
        PartnerOperators,
        Slick,
        PostPaidCardsOffers,
        PostPaidCardsZoneOffers,
        CardOffersPostPaid,
        CardOffersPrePaid,
        CardStandardTarifs,
    },
    data() {
        return {
            loadSliders: false,
            toggle_roaming: false,
            toggle_roaming_extins: false,
            toggle_roaming_pe_zi_1: false,
            toggle_roaming_pe_zi_2: false,
            toggle_roaming_50mb: false,
            toggle_internet: false,
            toggle_in_slide_1: false,
            toggle_in_slide_2: false,
            toggle_in_slide_3: false,
            toggle_in_slide_4: false,
            hrefActivate: this.$root.hrefActivate,
            slickOptions: {
                infinite: false,
                arrows: true,
                dots: false,
                speed: 500,
                // slidesToShow: 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                mobileFirst: true,
                autoplay: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            initialSlide: 1,
                        },
                    },
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                            initialSlide: 1,
                        },
                    },
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            initialSlide: 1,
                        },
                    },
                    {
                        breakpoint: 320,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            initialSlide: 1,
                            adaptiveHeight: true,
                        },
                    },
                ],
            },
        };
    },
    watch: {
        $route(newRoute, oldRoute) {
            if (newRoute.params.service !== oldRoute.params.service) {
                this.changeServiceByURL(newRoute.params.service);
            }
            if (newRoute.params.travelTime !== oldRoute.params.travelTime) {
                this.changeTravelTimeByURL(newRoute.params.travelTime);
            }

            // temp fix
            this.loadSliders = false;
            setTimeout(() => {
                this.loadSliders = true;
            }, 300);
        },
    },
    computed: {
        CURRENT_COUNTRY_ISO_CODE() {
            return this.$root.selectedCountry.countryCodeISO;
        },
        PREPAID() {
            if (!this.$root.selectedCountry) return {};
            else {
                return this.$root.zones[0].find((item) => item['Zona'] === 'PREPAID');
            }
        },
        tab_0_data() {
            if (!this.$root.selectedCountry) return {};
            else {
                return this.$root.zones[0].find((item) => item['Zona'] === this.$root.selectedCountry.postpaid);
            }
        },
        tab_1_data() {
            if (!this.$root.selectedCountry) return {};
            else {
                return this.$root.zones[1].find((item) => item['Zona'] === this.$root.selectedCountry.prepaid);
            }
        },
        tab_2_data() {
            if (!this.$root.selectedCountry) return {};
            else {
                return this.$root.zones[2].find((item) => item['Zona'] === this.$root.selectedCountry.internet);
            }
        },
        travelTipsSpace() {
            var prop;
            if (this.$root.serviceActive.url === 'abonament') {
                prop = 'postpaid';
            } else if (this.$root.serviceActive.url === 'cartela') {
                prop = 'prepaid';
            } else {
                prop = 'internet';
            }
            if (!this.$root.selectedCountry) return 1;
            else return this.$root.selectedCountry[prop] !== 1 ? 1 : 0;
        },
    },
    methods: {
        getDirection($event) {
            console.log($event);
        },
        changeRouteService(serviceURL) {
            this.$router.replace({
                name: 'destinatie',
                params: { country: this.$route.params.country, service: serviceURL },
            });
            dataLayer.push({
                event: 'microData',
                event_name: 'action_click',
                click_element_name: serviceURL,
                page_name: `Roaming ${this.$route.params.country} LP`,
            });
        },
        changeRouteTravelTime(travelTimeURL, travelTimeName) {
            this.$router.replace({
                name: 'destinatie',
                params: {
                    country: this.$route.params.country,
                    travelTime: travelTimeURL,
                },
            });
            dataLayer.push({
                event: 'microData',
                event_name: 'action_click',
                click_element_name: travelTimeName,
                page_name: `Roaming ${this.$route.params.country} LP`,
            });
        },
        changeServiceByURL(url) {
            this.$root.serviceActive = this.$root.services.find((service) => service.url === url);
            if (url === 'internet' || url === 'cartela') {
                this.$nextTick(() => {
                    // setTimeout(() => {
                    if (this.$refs['slickSlider-1']) this.$refs['slickSlider-1'].setPosition();
                    if (this.$refs['slickSlider-2']) this.$refs['slickSlider-2'].setPosition();
                    // }, 10);
                });
            }
        },
        changeTravelTimeByURL: function (url) {
            this.$root.travelTimeActive = this.$root.travelTimes.find((travelTime) => travelTime.url === url);
        },
    },
    mounted() {
        this.$root.serviceActive = this.$root.services[0];
        this.$root.travelTimeActive = this.$root.travelTimes[0];

        this.changeServiceByURL(this.$route.params.service);
        this.changeTravelTimeByURL(this.$route.params.travelTime);
        this.loadSliders = true;
    },
};
</script>
